export const CALENDAR_LINK = 'https://savvycal.com/affilimate/intro';
